var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMolionAmodiManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.7,19.1c-0.3,0-0.5-0.2-0.5-0.5v-7.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v7.8C21.2,18.9,20.9,19.1,20.7,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,15.5h-6.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.8c0.3,0,0.5,0.2,0.5,0.5S27.7,15.5,27.4,15.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27,12.1 27,17.9 30,15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.2,23.4 25.4,20.3 23.3,17.4 25.3,17.4 26.3,19 27.5,17.4 29.4,17.4 27.3,20.2 29.6,23.4 27.6,23.4 26.3,21.5  25.1,23.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.5,23.4 6.7,20.3 4.6,17.4 6.6,17.4 7.6,19 8.8,17.4 10.7,17.4 8.6,20.2 10.9,23.4 8.9,23.4 7.6,21.5 6.4,23.4  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,19.1c-0.3,0-0.5-0.2-0.5-0.5v-7.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v7.8C10.3,18.9,10.1,19.1,9.8,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3,15.5H2.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.8c0.3,0,0.5,0.2,0.5,0.5S9.6,15.5,9.3,15.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3,17.9 3,12.1 0,15  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,30c-0.6,0-1-0.4-1-0.9V0.9c0-0.5,0.4-0.9,1-0.9s1,0.4,1,0.9v28.1C16.2,29.6,15.8,30,15.2,30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolionAmodiManual);
export default __webpack_public_path__ + "static/media/molion_amodi_manual.6e646cea75f75981470d1c0ef4ff89d6.svg";
export { ForwardRef as ReactComponent };